import React from 'react'
import { IonSplitPane, IonContent } from '@ionic/react'
import { useSelector } from 'react-redux'
import AddPatientInformation from '../addPatientInformation/AddPatientInformation.component'
import { getPatientInformationState } from '../selectors'
import { PatientInformationConstants } from '../store/patientInformation.constants'
import PatientAllergiesContent from '../../patientAllergies/patientAllergiesContent/PatientAllergiesContent.component'
import PatientDemographicsContent from '../../patientDemographics/patientDemographicsContent/PatientDemographicsContent.component'
import PatientAllergiesSearchListContent from '../../patientAllergies/patientAllergiesContent/PatientAllergiesSearchListContent.component'
import PatientMedicalHistoryContent from '../../patientMedicalHistory/patientMedicalHistoryContent/PatientMedicalContent.component'
import PatientMedicationsContent from '../../patientMedications/pageContent/PatientMedications.content'
import MedicalHistoryLookupContent from '../../patientMedicalHistory/medicalHistoryLookup/MedicalHistoryLookupContent.component'
import DoNotResuscitateContent from '../../patientDemographics/doNotResuscitateSection/DoNotResuscitate.component'
import PatientSearchResultsContent from '../../patientSearch/pageContent/PatientSearchResults.content'
import PatientSearchContent from '../../patientSearch/pageContent/PatientSearch.content'
import BarriersToCareContent from '../../patientDemographics/barriersToCare/BarriersToCare.component'
import './PatientInformationTablet.component.css'
import PreferredLanguageContent from '../../patientDemographics/preferredLanguage/PreferredLanguage.content'

const PatientInformationTablet: React.FC = () => {
  const { selectedOption } = useSelector(getPatientInformationState)
  const disableScrollClass =
    selectedOption === PatientInformationConstants.PATIENT_ALLERGIES_SEARCH_LIST_OPTION ? 'disable-scroll' : ''
  return (
    <>
      <IonSplitPane content-id='main-content' className='no-scroll'>
        <AddPatientInformation />
        <IonContent
          id='main-content'
          color='light'
          fullscreen
          scrollY={
            selectedOption === PatientInformationConstants.PATIENT_MEDICAL_HISTORY_SEARCH_LIST_OPTION ? false : true
          }
          className={disableScrollClass}>
          {selectedOption === PatientInformationConstants.PATIENT_SEARCH_OPTION && <PatientSearchContent />}
          {selectedOption === PatientInformationConstants.PATIENT_SEARCH_RESULTS_OPTION && (
            <PatientSearchResultsContent />
          )}
          {selectedOption === PatientInformationConstants.PATIENT_DEMOGRAPHICS_OPTION && <PatientDemographicsContent />}
          {selectedOption === PatientInformationConstants.PATIENT_ALLERGIES_OPTION && <PatientAllergiesContent />}
          {selectedOption === PatientInformationConstants.PATIENT_ALLERGIES_SEARCH_LIST_OPTION && (
            <PatientAllergiesSearchListContent />
          )}
          {selectedOption === PatientInformationConstants.PATIENT_MEDICAL_HISTORY_OPTION && (
            <PatientMedicalHistoryContent />
          )}
          {selectedOption === PatientInformationConstants.PATIENT_MEDICAL_HISTORY_SEARCH_LIST_OPTION && (
            <MedicalHistoryLookupContent />
          )}
          {selectedOption === PatientInformationConstants.PATIENT_MEDICATION_OPTION && <PatientMedicationsContent />}
          {selectedOption === PatientInformationConstants.SET_DO_NOT_RESUSCITATE && <DoNotResuscitateContent />}
          {selectedOption === PatientInformationConstants.SET_BARRIERS_TO_CARE && <BarriersToCareContent />}
          {selectedOption === PatientInformationConstants.SET_PREFERRED_LANGUAGE && <PreferredLanguageContent />}
        </IonContent>
      </IonSplitPane>
    </>
  )
}

export default PatientInformationTablet
